<template>
  <div class="Polaris-LegacyCard">
    <div
      class="Polaris-LegacyCard__Section Polaris-LegacyCard__FirstSectionPadding Polaris-LegacyCard__LastSectionPadding"
    >
      <div
        class="Polaris-Box"
        style="--pc-box-padding-block-start-xs:var(--p-space-500);--pc-box-padding-block-end-xs:var(--p-space-1600);--pc-box-padding-inline-start-xs:var(--p-space-0);--pc-box-padding-inline-end-xs:var(--p-space-0)"
      >
        <div
          class="Polaris-BlockStack"
          style="--pc-block-stack-inline-align:center;--pc-block-stack-order:column"
        >
          <div class="Polaris-EmptyState__ImageContainer">
            <img
              alt=""
              src="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
              class="Polaris-EmptyState__Image Polaris-EmptyState--loaded"
              role="presentation"
            />
            <div
              class="Polaris-EmptyState__SkeletonImage Polaris-EmptyState--loaded"
            ></div>
          </div>
          <div class="Polaris-Box" style="--pc-box-max-width:400px">
            <div
              class="Polaris-BlockStack"
              style="--pc-block-stack-inline-align:center;--pc-block-stack-order:column"
            >
              <div
                class="Polaris-Box"
                style="--pc-box-padding-block-end-xs:var(--p-space-400)"
              >
                <div
                  class="Polaris-Box"
                  style="--pc-box-padding-block-end-xs:var(--p-space-150)"
                >
                  <p
                    class="Polaris-Text--root Polaris-Text--headingMd Polaris-Text--block Polaris-Text--center"
                  >
                    {{title}}
                  </p>
                </div>
                <span
                  class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--block Polaris-Text--center"
                >
                  <p>
                    {{ description }}
                  </p>
                </span>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "EmptyState",
  props: {
    title: { type: String },
    description: { type: String }
  },
  methods: {}
};
</script>

<style lang="scss" scoped></style>
